import qs from 'qs';
import http from './http';
import constant from './constant';

/** 向后端提交账号密码, 手机验证码, 获取当前登录流程, 都是这一个接口 */
export const login = params => {
    const {data, search = ''} = params;
    return http.post(`${constant.LOGIN.POST_LOGIN}${search}`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};
export const loginPwd = params => {
    const {data, search = ''} = params;
    return http.post(`${constant.LOGIN.POST_LOGIN_ACCOUNT_PASSWORD}${search}`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};
export const loginPhone = params => {
    const {data, search = ''} = params;
    return http.post(`${constant.LOGIN.POST_LOGIN_PHONE_CODE}${search}`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};
export const loginQrCode = params => {
    const {data, search = ''} = params;
    return http.post(`${constant.LOGIN.POST_LOGIN_QR_CODE}${search}`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};

export const sendSmsCodeService = params => http.post(constant.LOGIN.SEND_SMS_CODE, qs.stringify(params), {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
});
export const getCAPTCHA = params => http.get(constant.LOGIN.GET_CAPTCHA, {params});

export const logout = params => {
    const {data, search = ''} = params;
    return http.post(`${constant.LOGIN.POST_LOGOUT}${search}`, qs.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};
